import { render, staticRenderFns } from "./EasyInput.vue?vue&type=template&id=1670675d&"
import script from "./EasyInput.vue?vue&type=script&lang=js&"
export * from "./EasyInput.vue?vue&type=script&lang=js&"
import style0 from "./EasyInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports